/* eslint-disable import/prefer-default-export */
import React from 'react';

export const useCreatableSelect = (initialOptions) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [options, setOptions] = React.useState(initialOptions);
  const createOption = (label) => ({
    label,
    value: label,
    // value: label.toLowerCase().replace(/\W/g, ''),
  });

  const create = async (inputValue, beforeCreate, createQuery) => {
    let newOption = createOption(inputValue);
    if (beforeCreate) {
      newOption = beforeCreate(newOption);
    }
    if (createQuery) {
      setIsLoading(true);
      const createdOption = await createQuery(inputValue);
      setOptions([...initialOptions, createdOption]);
      setIsLoading(false);
      return createdOption;
    }
    setOptions([...initialOptions, newOption]);
    return newOption;
  };

  React.useEffect(() => {
    setOptions(initialOptions);
  }, [JSON.stringify(initialOptions)]);

  return {
    create,
    options,
    isLoading,
  };
};
